import React from 'react';
import WixSDK from 'shared/utils/wix-sdk';
import debounce from 'core-decorators/lib/debounce';
import autobind from 'core-decorators/lib/autobind';
import { getScreenSizeByUserAgent, isLandscape } from 'shared/utils/device/screen';


export function isMobileWidgetVisibleInViewPort() {
  return WixSDK.getBoundingRectAndOffsets()
    .then(data => {
      const { rect: { top, bottom } } = data;

      const { width, height } = getScreenSizeByUserAgent();
      const screenHeight = isLandscape() ? width : height;

      return (top <= 0 && bottom >= screenHeight) || (top >= 0 && bottom <= screenHeight);
    });
}

export const visibleInViewPort = WrappedComponent => {

  class VisibleInViewPort extends React.Component {

    state = {
      isVisible: false,
    };

    componentWillMount() {
      this.check();
      WixSDK.addEventListener(WixSDK.Events.SCROLL, this.check);
    }

    componentWillUnmount() {
      WixSDK.removeEventListener(WixSDK.Events.SCROLL, this.check);
    }

    @autobind
    @debounce(400)
    check() {
      isMobileWidgetVisibleInViewPort()
        .then(this.updateVisibility);
    }

    @autobind
    updateVisibility(newIsVisible) {
      if (newIsVisible !== this.state.isVisible) {
        this.setState({
          isVisible: newIsVisible,
        });
      }
    }

    render() {
      return (
        <WrappedComponent {...this.props}
                          isVisibleInViewport={this.state.isVisible} />
      );
    }
  }

  VisibleInViewPort.WixWrappedComponent = WrappedComponent;

  return VisibleInViewPort;
};



// WEBPACK FOOTER //
// ./src/mobile/utils/visible-on-screen.js